import { useAuth } from '@/app/hooks/useAuth'
import { Consultas } from '../Consultas'
import { Radar } from '../Clientes/CustomerRadar'

export function RadarPage() {
  const { isSuperAdmin, isAdmin } = useAuth()

  if (isSuperAdmin || isAdmin) {
    return <Consultas />
  }

  return <Radar />
}
